export default "__VITE_ASSET__cvXI4hqG__"